import AuthLangs from '../apps/auth/AuthLangs';
import InvestorLangs from '../apps/investor/InvestorLangs';
import AdminLangs from '../apps/admin/AdminLangs';
import AppFeatureLangs from './features/AppFeatureLangs';
import appLayoutLang from './langs/appLayoutLang';
import appFormatLang from './features/format/langs/appFormatLang';
import HomeLangs from '../apps/home/HomeLangs';
import appErrorBoundaryLang from './features/error/boundary/langs/appErrorBoundaryLang';
import FaqLangs from '../apps/faq/FaqLangs';
import appErrorProbeLang from './features/error/probe/langs/appErrorProbeLang';
import NewsLangs from '../apps/news/NewsLangs';
import DocumentLangs from '../apps/document/DocumentLangs';
import ContactsLangs from '../apps/contacts/ContactsLang';
import MiscLangs from '../apps/misc/MiscLangs';
import { TAppLangModule } from './utils/i18nTypes';

const allAppLangs: TAppLangModule[][] = [
	[appLayoutLang, appFormatLang, appErrorBoundaryLang, appErrorProbeLang],
	AuthLangs,
	DocumentLangs,
	FaqLangs,
	HomeLangs,
	InvestorLangs,
	NewsLangs,
	AdminLangs,
	AppFeatureLangs,
	ContactsLangs,
	MiscLangs,
];

const AppLangs: TAppLangModule[] = allAppLangs.flat();

export default AppLangs;
